"use strict";

var _regeneratorRuntime = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/helpers/asyncToGenerator");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var v4_1 = __importDefault(require("uuid/v4"));

var app_1 = __importDefault(require("firebase/app"));

var lodash_1 = __importDefault(require("lodash"));

var app_2 = __importDefault(require("../../constants/app"));

var _app_2$default = app_2.default,
    REMOTE_STORAGE_BUCKET_IMAGE = _app_2$default.REMOTE_STORAGE_BUCKET_IMAGE,
    REMOTE_STORAGE_BUCKET_ICON = _app_2$default.REMOTE_STORAGE_BUCKET_ICON;
var _pngContentType = 'image/png';

function _buildPath(_x, _x2) {
  return _buildPath2.apply(this, arguments);
}

function _buildPath2() {
  _buildPath2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(bucket, name) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", "".concat(bucket, "/").concat(name));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _buildPath2.apply(this, arguments);
}

function _buildPublicPath(bucket) {
  var name = v4_1.default();
  return "public/".concat(bucket, "/").concat(name);
}

function uploadImage(_x3) {
  return _uploadImage.apply(this, arguments);
}

function _uploadImage() {
  _uploadImage = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(localFilePath) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _uploadByPath(localFilePath, _buildPublicPath(REMOTE_STORAGE_BUCKET_IMAGE), _pngContentType);

          case 2:
            return _context2.abrupt("return", _context2.sent);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _uploadImage.apply(this, arguments);
}

exports.uploadImage = uploadImage;

function uploadIcon(_x4) {
  return _uploadIcon.apply(this, arguments);
}

function _uploadIcon() {
  _uploadIcon = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(localFilePath) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _uploadByPath(localFilePath, _buildPublicPath(REMOTE_STORAGE_BUCKET_ICON), _pngContentType);

          case 2:
            return _context3.abrupt("return", _context3.sent);

          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _uploadIcon.apply(this, arguments);
}

exports.uploadIcon = uploadIcon;

function uploadImageByFileInfoBlob(_x5) {
  return _uploadImageByFileInfoBlob.apply(this, arguments);
}

function _uploadImageByFileInfoBlob() {
  _uploadImageByFileInfoBlob = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(fileInfoBlob) {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _uploadByBlob(fileInfoBlob, _buildPublicPath(REMOTE_STORAGE_BUCKET_IMAGE));

          case 2:
            return _context4.abrupt("return", _context4.sent);

          case 3:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _uploadImageByFileInfoBlob.apply(this, arguments);
}

exports.uploadImageByFileInfoBlob = uploadImageByFileInfoBlob;

function uploadIconByFileInfoBlob(_x6) {
  return _uploadIconByFileInfoBlob.apply(this, arguments);
}

function _uploadIconByFileInfoBlob() {
  _uploadIconByFileInfoBlob = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5(fileInfoBlob) {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _uploadByBlob(fileInfoBlob, _buildPublicPath(REMOTE_STORAGE_BUCKET_ICON));

          case 2:
            return _context5.abrupt("return", _context5.sent);

          case 3:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _uploadIconByFileInfoBlob.apply(this, arguments);
}

exports.uploadIconByFileInfoBlob = uploadIconByFileInfoBlob;

function _uploadByBlob(_x7, _x8) {
  return _uploadByBlob2.apply(this, arguments);
}

function _uploadByBlob2() {
  _uploadByBlob2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee6(fileInfoBlob, destPath) {
    var blob, ref, snapshot, remoteUri;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            blob = lodash_1.default.get(fileInfoBlob, '_blob', null);

            if (!blob) {
              _context6.next = 12;
              break;
            }

            ref = app_1.default.storage().ref().child(destPath);
            _context6.next = 5;
            return ref.put(blob);

          case 5:
            snapshot = _context6.sent;
            _context6.next = 8;
            return snapshot.ref.getDownloadURL();

          case 8:
            remoteUri = _context6.sent;
            return _context6.abrupt("return", {
              ref: destPath,
              uri: remoteUri,
              type: 'GC'
            });

          case 12:
            throw new Error('[CoDB] Passing a file info without blob');

          case 13:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _uploadByBlob2.apply(this, arguments);
}

function _uploadByPath(_x9, _x10, _x11) {
  return _uploadByPath2.apply(this, arguments);
}

function _uploadByPath2() {
  _uploadByPath2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee7(localFilePath, destPath, fallbackContentType) {
    var blob, size, type, ref, snapshot, remoteUri;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return new Promise(function (resolve, reject) {
              var xhr = new XMLHttpRequest();

              xhr.onload = function () {
                resolve(xhr.response);
              };

              xhr.onerror = function () {
                reject(new TypeError('[CoDB Storage] Network request failed'));
              };

              xhr.responseType = 'blob';
              xhr.open('GET', localFilePath, true);
              xhr.send(null);
            });

          case 2:
            blob = _context7.sent;
            size = blob.size, type = blob.type;

            if (!(size === 0)) {
              _context7.next = 7;
              break;
            }

            console.warn('Blob can be fetch, but not size info');
            throw new TypeError('[CoDB] Failed to get file size');

          case 7:
            if (type) {
              _context7.next = 10;
              break;
            }

            console.warn('Careful, the blob can be fetch but not type info');
            throw new TypeError('[CoDB] Failed to get file type');

          case 10:
            ref = app_1.default.storage().ref().child(destPath);
            _context7.next = 13;
            return ref.put(blob);

          case 13:
            snapshot = _context7.sent;
            _context7.next = 16;
            return snapshot.ref.getDownloadURL();

          case 16:
            remoteUri = _context7.sent;
            blob.close();
            return _context7.abrupt("return", {
              ref: destPath,
              uri: remoteUri,
              type: 'GC'
            });

          case 19:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _uploadByPath2.apply(this, arguments);
}

function checkIfRemoteImgPath(uri) {
  return uri.indexOf("https://") === 0;
}

exports.checkIfRemoteImgPath = checkIfRemoteImgPath;